import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useSearchParams, useNavigate } from 'react-router-dom';
import WizardPage from './pages/WizardPage';
import CalculatorPage from './pages/CalculatorPage';

// Component to handle 404.html redirect routes
const RouteHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if this is a redirect from 404.html (contains _route parameter)
    const route = searchParams.get('_route');
    if (route) {
      // Remove the _route parameter and navigate to the correct route
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('_route');
      const queryString = newParams.toString();
      const path = '/' + route + (queryString ? '?' + queryString : '');
      navigate(path, { replace: true });
    }
  }, [searchParams, navigate]);

  return null;
};

const Router = () => {
  return (
    <BrowserRouter>
      <RouteHandler />
      <Routes>
        {/* Home page shows wizard */}
        <Route path="/" element={<WizardPage />} />

        {/* Calculator page shows results with sidebar */}
        <Route path="/calculator" element={<CalculatorPage />} />

        {/* Redirect any unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;